import { defineComponent as _defineComponent } from 'vue'
type StyleMap = Record<string, string | undefined>


export default /*#__PURE__*/_defineComponent({
  __name: 'RtCommonOtherJobButton',
  props: {
    buttonId: { default: 'rt-common-other-job-btn' },
    buttonStyle: { default: () => ({}) },
    innerStyle: { default: () => ({}) },
    label: { default: '他の仕事紹介も希望する' },
    visible: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ((e: 'click') => void), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit }
}

})